export interface AdaSettings {
  handle: string;
  cluster: string;
  toggleCallback?: (isOpened: boolean) => void;
  onAdaEmbedLoaded?: () => void;
  conversationEndCallback?: () => void;
}

export const adaSettings: AdaSettings = {
  handle: 'kaseya',
  cluster: 'us2',
};
